import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-1 text-left text-xs text-red-600" }



import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';


export default /*@__PURE__*/_defineComponent({
  __name: 'MetricInput',
  props: {
    error: {},
    type: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["text-bluegray-600 block flex-1 text-left text-sm font-normal", _ctx.$attrs.class])
  }, [
    _renderSlot(_ctx.$slots, "label"),
    _createVNode(_unref(InputGroup), null, {
      default: _withCtx(() => [
        _createVNode(_unref(InputGroupAddon), null, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "metric")
          ]),
          _: 3
        }),
        (_ctx.type === 'string')
          ? (_openBlock(), _createBlock(_unref(InputText), _mergeProps({ key: 0 }, _ctx.$attrs, {
              class: "mt-1 block w-full !pl-16",
              invalid: !!_ctx.error
            }), null, 16, ["invalid"]))
          : (_ctx.type === 'number')
            ? (_openBlock(), _createBlock(_unref(InputNumber), _mergeProps({ key: 1 }, _ctx.$attrs, {
                class: "w-full",
                invalid: !!_ctx.error,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.value)))
              }), null, 16, ["invalid"]))
            : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createElementVNode("small", _hoisted_1, _toDisplayString(_ctx.error), 1)
  ], 2))
}
}

})